module.exports = __webpack_public_path__ + "media/assets/site_images/photos_gallery/photo5-4f647166988d571af4d3d04ad34a9851.jpg";